import { PUBLISH_DRAG_SOURCE } from './types';
export default function createPublishDragSource(manager) {
  return function publishDragSource() {
    var monitor = manager.getMonitor();

    if (monitor.isDragging()) {
      return {
        type: PUBLISH_DRAG_SOURCE
      };
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/dnd-core/dist/esm/actions/dragDrop/publishDragSource.js
// module id = 656
// module chunks = 4